import React from 'react';

// Soft-clay 3D icons (public/images/icons, rendered at 2x). Decorative: the
// text next to each one says what it means.
function ClayIcon({ name, size = 64, className = '' }) {
  return (
    <img
      src={`/images/icons/${name}.webp`}
      alt=""
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
      className={`shrink-0 ${className}`}
      style={{ width: size, height: size }}
    />
  );
}

export default ClayIcon;
